import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/wordSlide/data/constants';

const initState = {
  currentScreen: SCREENS.PROGRESS,
  returnToScreen: SCREENS.PROGRESS,
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (type === 'SELECT_ACTIVITY' && payload.activity === GAME_ID) {
    return initState;
  }

  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        currentScreen: payload.screen,
        returnToScreen: payload.returnTo,
      };

    default:
      return state;
  }
};

export default screenReducer;
